"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUndefined = void 0;
const isUndefined = (variable) => {
    return typeof variable === 'undefined';
};
exports.isUndefined = isUndefined;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXMtdW5kZWZpbmVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3V0aWwvbG9kYXNoLWZ1bmN0aW9ucy9pcy11bmRlZmluZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQU8sTUFBTSxXQUFXLEdBQUcsQ0FBQyxRQUFhLEVBQUUsRUFBRTtJQUN6QyxPQUFPLE9BQU8sUUFBUSxLQUFLLFdBQVcsQ0FBQztBQUMzQyxDQUFDLENBQUM7QUFGVyxRQUFBLFdBQVcsZUFFdEIifQ==